export const resumeData = {
  personalInfo: {
    name: 'Stanley Chan',
    email: 'stanley.chan.social@gmail.com',
    linkedin: 'www.linkedin.com/in/schanjr/',
    phone: '+1-415-851-4923',
    github: 'www.github.com/schanjr',
    blog: 'www.schanjr.blog'
  },

  technicalLeadership: [
    '12+ years building enterprise-grade systems with quality-first approach resulting in reliable, scalable solutions.',
    'Product engineering leader with proven ability to build systems that customers love.',
    'Team productivity multiplier: creating reusable tools, platforms, and best practices that engineers adopt.'
  ],

  professionalExperience: [
    {
      company: 'Material Bank (Series D)',
      domain: 'materialbank.com',
      position: 'Lead/Staff Software Engineer (Internal Engineering)',
      duration: 'April 2024 – Present',
      achievements: [
        'Built enterprise-grade product infrastructure: VPN, SSO integration, disaster recovery protocols, contract driven development, and Infrastructure as Code.',
        'Led cross-team technical strategy across multiple revenue-critical systems, protecting $80M revenue streams.',
        'Architected real-time warehouse scheduling system and multi-tenant billing platform for www.DesignShop.com.',
        'Rearchitected legacy leads generation system achieving 99% data accuracy and 5x reporting throughput.',
        'Tech Stack: Python, JavaScript, FastAPI, React.js, PostgreSQL, DynamoDB, AWS ECS, Terraform'
      ]
    },
    {
      company: 'Cloud Software Group (Citrix)',
      domain: 'citrix.com',
      position: 'Senior Software Engineer (Frontend)',
      duration: 'July 2023 – April 2024',
      achievements: [
        'Scaled Inner Source Maintainers group for React.js UI libraries across 5+ teams (20+ Engineers).',
        'Created reusable authentication middleware for Golang microservices.',
        'Promoted value-based engineering through data-driven processes and user research.',
        'Tech Stack: React.js, Golang, Micro-frontends, Jenkins, Kubernetes, Azure'
      ]
    },
    {
      company: 'Atlas Inc., Singapore (YC Startup)',
      domain: 'atlas.kitchen',
      position: 'Principal Software Engineer (Backend)',
      duration: 'July 2022 – Feb 2023',
      achievements: [
        'Established engineering foundations as one of 5 engineers, defining technical standards and architecture.',
        'Designed scalable data layer with PGBouncer clustering supporting 10k+ concurrent connections.',
        'Stabilized mission-critical payments system (Authorization, Capture, Payouts) contributing to higher GMV.',
        'Implemented distributed tracing capabilities for observability and faster MTTR.',
        'Tech Stack: Ruby on Rails, PostgreSQL, PgBouncer, OpenTelemetry, GCP'
      ]
    },
    {
      company: 'Autodesk Inc., Singapore',
      domain: 'autodesk.com',
      position: 'Senior Software Engineer (Backend)',
      duration: 'July 2018 – July 2022',
      achievements: [
        'Mentored engineering team (8 personnel) on code base handover, Agile practices, and end-to-end ownership.',
        'Primary contributor to microservices design and architecture.',
        'Increased team observability through alarms, alerts, and visualization tools.',
        'Tech Stack: JRuby, Node.js, Golang, Terraform, AWS ECS, PostgreSQL, Redis'
      ]
    },
    {
      company: 'Autodesk Inc., San Francisco',
      domain: 'autodesk.com',
      position: 'Software Engineer (Backend)',
      duration: 'January 2015 – June 2018',
      achievements: [
        'Increased code coverage 80%+ for backend services supporting one-click CICD pipeline.',
        'Built RESTful APIs at scale enabling global access to Autodesk products and services.',
        'Optimized SQL queries for User/Subscription data and modernized applications with Docker.',
        'Created KPI dashboards and health checks using Splunk and AppDynamics.',
        'Tech Stack: JRuby, Node.js, Terraform, AWS EC2, PostgreSQL, Elasticsearch'
      ]
    },
    {
      company: 'Autodesk Inc., San Francisco',
      domain: 'autodesk.com',
      position: 'Business Systems Analyst (QA)',
      duration: 'November 2013 – December 2014',
      achievements: [
        'Full SDLC experience in Agile Scrum environment coordinating BI and MI teams.',
        'Investigated and resolved data integrity errors in Hive/Redshift systems.',
        'Built automation scripts for cleanups, failover, and notifications.',
        'Optimized data using partitions and bucketing techniques.',
        'Tech Stack: Hadoop, Hive, Redshift, SQL Server, Pig Scripts'
      ]
    }
  ],

  education: {
    university: 'Syracuse University, School of Information Studies, Syracuse, NY',
    degree: 'Bachelor of Science Dual Major: Information Technology/Finance (Graduated May 2013)',
    gpa: '(3.57/4.0)',
    honors: [
      'Dean\'s List (Fall 2009-2013)',
      'Renee Crown Honors Program (Spring 2009-2013)'
    ]
  },

  languages: ['English', 'Cantonese', 'Mandarin'],

  technicalExpertise: {
    programmingLanguages: ['Python', 'JRuby/Ruby', 'NodeJS/Javascript', 'Golang', 'SQL', 'Bash', 'Terraform'],
    providers: ['Amazon Web Services', 'Google Cloud Platform', 'Serverless', 'Heroku', 'Azure'],
    subjectMatterExpertise: ['Microservices/Monoliths', 'FMEA', 'Design Patterns', 'Modularity', 'Databases', 'Event Driven Apps', 'REST'],
    hobbies: ['Machine Learning', 'Programming', 'Data Analytics', 'Visualization', 'Blogging', 'Photography']
  },

  presentations: [
    {
      title: 'A Brief Intro to OpenTelemetry',
      url: 'https://prezi.com/view/6IcEolgRpqmHprkYqLEN/?referral_token=coBxr-lnB3FN'
    },
    {
      title: 'How Not to Fail Contract Driven Development',
      url: 'https://prezi.com/view/OluobzzUXxnTIfQPJfjB/?referral_token=coBxr-lnB3FN'
    },
    {
      title: 'How Big Tech Manage Projects',
      url: 'https://wp.me/p6tPtf-j8'
    },
    {
      title: 'Art of Persuasion',
      url: 'https://wp.me/p6tPtf-js'
    },
    {
      title: 'Structured Communications',
      url: 'https://wp.me/p6tPtf-gK'
    },
    {
      title: 'SQL Performance with Partitioning',
      url: 'https://wp.me/p6tPtf-lX'
    }
  ],

  technologiesAndFrameworks: {
    edgeNetwork: ['Cloudflare', 'Route53'],
    proxyServices: ['Apigee', 'AWS API Gateway', 'GraphQL'],
    frameworks: ['FastAPI', 'Ruby On Rails', 'Sinatra', 'Echo', 'Gin', 'Express.js', 'Next.js', 'React.js', 'Electron.js'],
    loadTesting: ['Blazemeter', 'JMeter', 'k6', 'Artillery'],
    storage: ['PostgreSQL', 'Mysql', 'Redis', 'S3', 'DynamoDB', 'Firebase', 'MongoDB'],
    messaging: ['SNS/SQS', 'RabbitMQ', 'Kafka'],
    dataAnalytics: ['Streamlit', 'Pandas', 'SciKit', 'R'],
    jobSchedulers: ['Airflow', 'Hatchet', 'Sidekiq', 'CloudTaskers', 'Bull.js'],
    orchestration: ['Elastic Container Service', 'Fargate', 'Hadoop'],
    testFrameworks: ['Rspec', 'NestJS', 'Mocha/Chai', 'Ginkgo/Gomega', 'Jest'],
    monitoringAndVisualization: ['OpenTelemetry', 'AppDynamics', 'Dynatrace', 'New Relic', 'Monit', 'Splunk', 'Kibana', 'Grafana'],
    cicd: ['Terraform', 'Jenkins', 'Circle CI', 'Github Actions'],
    specializations: ['Distributed Architecture', 'Observability', 'Performance Engineering', 'Platform Engineering', 'Monoliths', 'Micro Services']
  }
}
